export const AMEND_APPOINTMENT_REQUEST_TYPE = 'AMEND_APPOINTMENT';
export const AEM_HEADLESS_REQUEST_TYPE = 'AEM_HEADLESS';